import React, {useEffect, useState} from 'react'
import './inputNumber.css'
import {InputNumber as AntInputNumber, InputNumberProps} from 'antd'

interface Props extends InputNumberProps<number> {
    // max?: number
    // min?: number
    value?: number
    onChangeCount?: (count: number) => void
}

export const InputNumber = ({max = 1000, min = 0, value, controls, onChangeCount, ...rest}: Props) => {
    const [count, setCount] = useState(value || 1)
    useEffect(()=>{
        if(value) setCount(value)
    }, [value])

    const handleChangeDown = () => {
        console.log('handleChangeDown', count)
        setCount(count => {
            if (min < count) {
                count = count - 1
                onChangeCount && onChangeCount(count)
            }
            return count
        })
    }

    const handleChangeUp = () => {
        console.log('handleChangeUp', count)
        setCount(count => {
            if (max > count) {
                count = count + 1
                onChangeCount && onChangeCount(count)
            }
            return count
        })
    }

    const handleChangeCount: InputNumberProps['onChange'] = (value) => {
        let count = Number(value);

        console.log('handleChangeCount', count)
        if (count >= min && max >= count) {
            setCount(count)
            onChangeCount && onChangeCount(count)
        } else {
            setCount(prev => prev)
        }
    }

    return (
        <AntInputNumber
            controls={false}
            size={"middle"}
            addonBefore={<span className={"before"} onClick={handleChangeDown}>-</span>}
            addonAfter={<span className={"after"} onClick={handleChangeUp}>+</span>}
            maxLength={2}
            className={"input-number"}
            value={count}
            onChange={handleChangeCount}
            min={min}
            max={max}
            {...rest}
        />
    )
}
